import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import EditOrLock from './common/EditOrLock';

import { showModal } from '../../../actions/modal';

import { WAREHOUSE_TYPE_TRANSLATE } from '../../../config';
import Checkbox from '../../common/Checkbox';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  height: calc(100% - 24px);
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  border: 1px solid #ebebeb;

  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .warehouse-type {
    font-size: 13px;
    font-weight: 700;
    font-size: 13px;
  }

  .warehouse-title {
    font-weight: 700;
    margin-bottom: 6px;
    color: #323a46;
  }

  .help-tooltip-wrapper {
    margin-left: 0;
    color: #6e768e;
    line-height: 16px;
    font-weight: normal;

    i {
      margin-left: 2px;
    }
  }

  .card-title {
    display: flex;
    align-items: center;
    padding-top: 3px;
    padding-bottom: 21px;

    .header-title {
      font-size: 16px;
      margin-bottom: 6px;
    }

    .change-link {
      margin-top: -3px;
    }
  }

  .border-top {
    padding-top: 24px;
    padding-bottom: 14px;
  }
`;

const WarehouseBlock = (props) => {
  const { currentOrder, warehouses, currentWarehouse, handleEditOrder } = props;

  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const deliveryInfo = useSelector((state) => state.orders.deliveryInfo);

  const handleUpdateWarehouse = () => {
    dispatch(
      showModal('SelectWarehouse', {
        currentOrderCode: currentOrder.warehouseCode,
        warehouseCode: currentWarehouse ? currentWarehouse.code : null,
        currentWarehouse: currentWarehouse,
        handleChange: async (childrenWarehouseCode, newWarehouseCode) => {
          const newWarehouse = warehouses.find((w) => w.code === newWarehouseCode);

          const newOrder = {
            ...currentOrder,
            warehouseName: newWarehouse.title,
            warehouseCode:
              newWarehouse.operatorType === 'FULFILLMENT'
                ? childrenWarehouseCode.code
                : newWarehouse.warehouseCode,
          };
          handleEditOrder(newOrder);
        },
        currentOrder,
      }),
    );
  };

  const isFbm = (delivery) => {
    const deliveryCode = deliveryInfo?.find((info) => info.code === delivery?.code);
    return !!deliveryCode?.fbmType;
  };
  const handleChangeShippingOptions = (e, key) => {
    handleEditOrder({
      ...currentOrder,
      warehouseShippingOptions: {
        [key]: e.target.checked,
      },
    });
  };

  return (
    <Wrapper className={`card-box ${!currentWarehouse ? 'add-info' : ''}`}>
      <div style={{ display: 'flex' }} className="card-title">
        <div>
          <h4 className="header-title">{t('Склад')}</h4>
          {currentWarehouse ? (
            <div className="warehouse-type">
              <span className="help-tooltip-wrapper">
                {t(WAREHOUSE_TYPE_TRANSLATE[currentWarehouse.operatorType]) ||
                  currentWarehouse.operatorType}
                {` `}
                {currentWarehouse.operatorType === `FULFILLMENT` ? (
                  <>
                    {(() => {
                      if (currentOrder.warehouseFFExportError)
                        return (
                          <>
                            <i className="fe-alert-triangle" style={{ color: `#f1556c` }} />
                            <span className="help-tooltip">
                              {currentOrder.warehouseFFExportError &&
                                currentOrder.warehouseFFExportError}
                            </span>
                          </>
                        );
                      else if (currentOrder.warehouseFFSync)
                        return (
                          <>
                            <i className="fe-play-circle" style={{ color: `#1abc9c` }} />
                            <span className="help-tooltip">
                              {t('Заказ успешно выгружен в систему Фулфилмент:')}
                              {` `}
                              {currentOrder.warehouseFFSyncDate &&
                                moment(currentOrder.warehouseFFSyncDate).format(
                                  `DD.MM.YYYY HH:mm:ss`,
                                )}
                            </span>
                          </>
                        );
                      else if (!currentOrder.warehouseFFExported)
                        return (
                          <>
                            <i className="fe-pause-circle" style={{ color: `#98a6ad` }} />
                            <span className="help-tooltip">
                              {currentOrder.warehouseFFExportError &&
                                currentOrder.warehouseFFExportError}
                              {t('Заказ еще не выгружался в систему Фулфилмент')}
                            </span>
                          </>
                        );
                      else return null;
                    })()}
                  </>
                ) : null}
              </span>
            </div>
          ) : null}
        </div>
        <EditOrLock
          permissions={currentOrder.permissionList}
          permissionKey="WAREHOUSE_EDITABLE"
          action={handleUpdateWarehouse}
        />
      </div>
      {currentWarehouse ? (
        <Fragment>
          <div className="border-top" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="block-subtitle">{t('Отгрузка со склада')}</div>
          </div>
          <div className="card-content">
            <div className="warehouse-title">{currentWarehouse.title}</div>
            <div>{currentWarehouse.address.fullAddress}</div>
          </div>
        </Fragment>
      ) : (
        <div className="blocked-block">
          <div className="change-link" onClick={handleUpdateWarehouse}>
            {t('Добавить информацию')}
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default WarehouseBlock;
